import React, { useState, useEffect, useCallback } from 'react';
import './Gallery.css';

const Gallery = () => {
  const allGalleryItems = [
    {
      id: 1,
      image: '/curs1.jpg',
      type: 'image'
    },
    {
      id: 2,
      image: '/ELIBS_BBG.jpg',
      type: 'image'
    },
    {
      id: 3,
      image: '/ELIBS_WBG.jpg',
      type: 'image'
    },
    {
      id: 4,
      image: '/slider1.jpg',
      type: 'image'
    },
    {
      id: 5,
      image: '/slider2.jpg',
      type: 'image'
    },
    {
      id: 6,
      image: '/curs1.jpg',
      type: 'image'
    },
    {
      id: 7,
      image: '/ELIBS_BBG.jpg',
      type: 'image'
    },
    {
      id: 8,
      image: '/ELIBS_WBG.jpg',
      type: 'image'
    },
    {
      id: 9,
      image: '/slider1.jpg',
      type: 'image'
    },
    {
      id: 10,
      image: '/slider2.jpg',
      type: 'image'
    },
    {
      id: 11,
      image: '/curs1.jpg',
      type: 'image'
    }
  ];

  const [showAllPopup, setShowAllPopup] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const displayedItems = allGalleryItems.slice(0, 3);
  const remainingCount = allGalleryItems.length - 3;

  const handleImageClick = (item) => {
    setSelectedImage(item);
  };

  const closeModal = useCallback(() => {
    setSelectedImage(null);
  }, []);

  const closeAllPopup = useCallback(() => {
    setShowAllPopup(false);
  }, []);

  const handleMoreClick = () => {
    setShowAllPopup(true);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        if (selectedImage) {
          closeModal();
        } else if (showAllPopup) {
          closeAllPopup();
        }
      }
    };

    if (selectedImage || showAllPopup) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [selectedImage, showAllPopup, closeModal, closeAllPopup]);

  return (
    <section id="gallery" className="gallery section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Gallery</h2>
          <p className="section-subtitle">
            Explore our library solutions and projects
          </p>
        </div>
        
        <div className="gallery-grid">
          {displayedItems.map((item) => (
            <div 
              key={item.id} 
              className="gallery-card"
              onClick={() => handleImageClick(item)}
            >
              <div className="gallery-image-container">
                <img 
                  src={item.image} 
                  alt={`Gallery item ${item.id}`}
                  className="gallery-image"
                />
                <div className="gallery-overlay">
                  <div className="view-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="12" cy="12" r="3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          ))}
          
          <div className="gallery-card more-card" onClick={handleMoreClick}>
            <div className="more-card-content">
              <div className="more-icon">+</div>
              <div className="more-text">More</div>
              <div className="more-count">{remainingCount} more</div>
            </div>
          </div>
        </div>
      </div>

      {/* All Images Popup */}
      {showAllPopup && (
        <div className="all-images-popup" onClick={closeAllPopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={closeAllPopup} aria-label="Close">
              ×
            </button>
            <h3 className="popup-title">All Gallery Images</h3>
            <div className="popup-gallery-grid">
              {allGalleryItems.map((item) => (
                <div 
                  key={item.id} 
                  className="popup-gallery-card"
                  onClick={() => {
                    setSelectedImage(item);
                    setShowAllPopup(false);
                  }}
                >
                  <div className="popup-image-container">
                    <img 
                      src={item.image} 
                      alt={`Gallery item ${item.id}`}
                      className="popup-gallery-image"
                    />
                    <div className="popup-gallery-overlay">
                      <div className="view-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <circle cx="12" cy="12" r="3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Single Image Modal/Lightbox */}
      {selectedImage && (
        <div className="image-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal} aria-label="Close">
              ×
            </button>
            <img 
              src={selectedImage.image} 
              alt={`Gallery item ${selectedImage.id}`}
              className="modal-image"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;

